import { http } from "../utils/http.js";
/**
 * Ping the base bee URL. If connection was not successful throw error
 *
 * @param ky Ky instance for given Bee class instance
 */

export async function checkConnection(ky) {
  await http(ky, {
    path: ''
  });
}